<template>
  <div class="credit-card-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" class="col-form-label" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <button class="btn btn-primary" type="button" @click="addCard()">
          <span class="fab fa-cc-stripe fa-fw fa-lg"></span>&nbsp;&nbsp; Add New Credit Card
        </button>
        <br/><br/>
        <template v-for="card in value">
          <credit-card-display :object="card"></credit-card-display>
        </template>
        <p class="form-section-info">
          Payments are processed by <a href="https://stripe.com/au/">Stripe</a>.
          You may view their <a href="https://stripe.com/au/privacy/">Privacy
          Policy here.</a>
        </p>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/vuex/api'
import CreditCardDisplay from '@/components/displays/CreditCardDisplay'
import { mapGetters, mapActions } from 'vuex'
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'
import {
  LOAD_USER
} from '@/vuex/types'
export default {
  name: 'CreditCardInput',
  props: {
    value: {
      type: Array
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          required: false
        }
      }
    }
  },
  components: {
    CreditCardDisplay
  },
  data () {
    return {
      stripeHandler: false,
      isValid: false,
      isDirty: false,
      invalidMessage: this.options.label + ' is required'
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    ...mapGetters([
      'loadedUser'
    ])
  },
  async mounted () {
    this.deactivate()
    let $vm = this
    if (this.$route.params.account_id) {
      await this[LOAD_USER](this.$route.params.account_id)
      if (this.loadedUser) {
        this.stripeHandler = StripeCheckout.configure({
          key: this.loadedUser.Organization.stripePublicKey,
          locale: 'auto',
          token: async (token) => {
            let api = new Api()
            let val = await api.addCreditCard(token, $vm.loadedUser.uuid)
            this.validate(val)
          }
        })
      }
    }
  },
  methods: {
    validate (val = this.value) {
      if (!Array.isArray(val)) {
        let newVal = this.value
        newVal.push(val)
        val = newVal
      }
      this.$emit('input', val)
      this.isDirty = true
      this.isValid = true
      if (!val.length && this.options.required) {
        this.isValid = false
      }
    },
    ...mapActions([
      LOAD_USER
    ]),
    deactivate () {
      if (this.stripeHandler) {
        this.stripeHandler.close()
        let stripeModal = document.querySelector('iframe.stripe_checkout_app')
        stripeModal.parentNode.removeChild(stripeModal)
      }
    },
    addCard () {
      this.stripeHandler.open({
        name: this.loadedUser.Organization.companyName,
        description: 'Payment Details',
        currency: 'AUD',
        panelLabel: 'Save Details',
        allowRememberMe: true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CreditCardInput.vue